<script setup>
const personBooks = inject('personBooks')
</script>

<template>
	<span v-if="!personBooks.length">
		<slot name="header" />
		<i class="text-muted">{{ $t('No books found.') }}</i>
	</span>
	<template v-else>
		<theme-base-swiper
			v-slot="slotProps"
			tag="section"
			:title="$t('Articles')"
			title-classes="fw-bold mb-3"
			:items="personBooks"
			:columns="{
				xs: 6,
				md: 3,
				xl: 2,
			}"
			url="/nieuws"
			class="mb-5"
			inline
		>
			<theme-card-book
				:item="slotProps.item"
				tag="article"
			/>
		</theme-base-swiper>
	</template>
</template>
